"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _translation = _interopRequireDefault(require("../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* eslint-disable react-hooks/exhaustive-deps */

const ListingsHeaderFilter = props => {
  const {
    activeCompany = '',
    activeSearchText = '',
    activeSortDirection,
    applyFilter,
    className = null,
    labels,
    lang = 'en',
    searchType = ''
  } = props;
  const disableReorder = ['owner', 'progress', 'status', 'tags', 'team'];
  const [activeSort, setActiveSort] = searchType === 'Properties' ? (0, _react.useState)('Updated') : (0, _react.useState)('Signup Date');
  const [previousSort, setPreviousSort] = searchType === 'Properties' ? (0, _react.useState)('Updated') : (0, _react.useState)('Signup Date');
  const [activeLabel, setActiveLabel] = searchType === 'Properties' ? (0, _react.useState)('Updated') : (0, _react.useState)('Signup Date');
  const [enterCounter, setEnterCounter] = (0, _react.useState)(0);
  let dir = '';
  const processFilter = (text, type, direction, company) => {
    let processedType = type.toLowerCase();
    if (disableReorder.includes(processedType)) {
      return false;
    }
    setActiveSort(type);
    // Exception for 'updatedAt'
    if (processedType.includes('last login')) {
      processedType = 'lastLogin';
    }
    if (processedType.includes('signup date')) {
      processedType = 'createdAt';
    }
    if (processedType.includes('channel')) {
      processedType = 'signupChannel';
    }
    if (processedType.includes('updated')) {
      processedType = 'updatedAt';
    }
    if (previousSort === 'Signup Date' && type === 'Last login' || previousSort === 'Last login' && type === 'Signup Date' || (previousSort === 'Name' || previousSort === 'Email' || previousSort === 'Signup channel') && (type === 'Signup Date' || type === 'Last login')) {
      if (direction === 'DESC') dir = 'DESC';
      if (direction === 'ASC') dir = 'DESC';
    } else if (searchType === 'Users' && previousSort === 'Signup Date' && type === 'Signup Date' && enterCounter === 0) {
      dir = direction;
      setEnterCounter(1);
    } else if (searchType === 'Properties' && enterCounter === 0) {
      dir = direction;
      setEnterCounter(1);
    } else if (direction === 'DESC') dir = 'ASC';else if (direction === 'ASC') dir = 'DESC';
    applyFilter(text, processedType, dir, company);
    return null;
  };
  (0, _react.useEffect)(() => {
    processFilter(activeSearchText, activeLabel, activeSortDirection, activeCompany);
  }, [previousSort, activeLabel]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `listings-header-filter dis-fl-row row-cols-${labels.length} px-2 ${className}`
  }, labels.map((label, i) => (/*#__PURE__*/_react.default.createElement("div", {
    key: `lbl_${i.toString()}`,
    className: "header row-section pl-1 dis-f a-c tt-up"
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: () => {
      setPreviousSort(activeSort);
      if (label === activeLabel) {
        processFilter(activeSearchText, activeLabel, activeSortDirection, activeCompany);
      } else {
        setActiveLabel(label);
      }
    },
    className: "wrapper pos-r dis-fl-row a-c"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: `fsize-200 ${activeSort === label ? 'active fweight-500' : ''} ${!disableReorder.includes(label.toLowerCase()) ? 'cur-poi' : ''} mr-1 `
  }, (0, _translation.default)(label, lang)), !disableReorder.includes(label.toLowerCase()) && (/*#__PURE__*/_react.default.createElement("p", {
    className: "dis-fl-col"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: `icon-arrow-up-small txtText900 fsize-400 ${activeSort === label && activeSortDirection === 'ASC' ? 'active' : 'hide'}`
  }), /*#__PURE__*/_react.default.createElement("i", {
    className: `icon-arrow-down-small txtText900 fsize-400 ${activeSort === label && activeSortDirection === 'DESC' ? 'active' : 'hide'}`
  }))))))));
};
var _default = exports.default = ListingsHeaderFilter;